// ** Healthcare Support
export const LIST_HEALTHCARE_SUPPORT_REQUEST = 'LIST_HEALTHCARE_SUPPORT_REQUEST'
export const LIST_HEALTHCARE_SUPPORT_SUCCESS = 'LIST_HEALTHCARE_SUPPORT_SUCCESS'
export const LIST_HEALTHCARE_SUPPORT_FAIL = 'LIST_HEALTHCARE_SUPPORT_FAIL'

export const DELETE_HEALTHCARE_SUPPORT_REQUEST = 'DELETE_HEALTHCARE_SUPPORT_REQUEST'
export const DELETE_HEALTHCARE_SUPPORT_SUCCESS = 'DELETE_HEALTHCARE_SUPPORT_SUCCESS'
export const DELETE_HEALTHCARE_SUPPORT_FAIL = 'DELETE_HEALTHCARE_SUPPORT_FAIL'

export const HEALTHCARE_SUPPORT_SUMMARY_REQUEST = 'HEALTHCARE_SUPPORT_SUMMARY_REQUEST'
export const HEALTHCARE_SUPPORT_SUMMARY_SUCCESS = 'HEALTHCARE_SUPPORT_SUMMARY_SUCCESS'
export const HEALTHCARE_SUPPORT_SUMMARY_FAIL = 'HEALTHCARE_SUPPORT_SUMMARY_FAIL'

export const HEALTHCARE_SUPPORT_RESET = 'HEALTHCARE_SUPPORT_RESET'

// ** Healthcare Support - Doctor
export const CREATE_HEALTHCARE_SUPPORT_DOCTOR_REQUEST = 'CREATE_HEALTHCARE_SUPPORT_DOCTOR_REQUEST'
export const CREATE_HEALTHCARE_SUPPORT_DOCTOR_SUCCESS = 'CREATE_HEALTHCARE_SUPPORT_DOCTOR_SUCCESS'
export const CREATE_HEALTHCARE_SUPPORT_DOCTOR_FAIL = 'CREATE_HEALTHCARE_SUPPORT_DOCTOR_FAIL'

export const DETAIL_HEALTHCARE_SUPPORT_DOCTOR_REQUEST = 'DETAIL_HEALTHCARE_SUPPORT_DOCTOR_REQUEST'
export const DETAIL_HEALTHCARE_SUPPORT_DOCTOR_SUCCESS = 'DETAIL_HEALTHCARE_SUPPORT_DOCTOR_SUCCESS'
export const DETAIL_HEALTHCARE_SUPPORT_DOCTOR_FAIL = 'DETAIL_HEALTHCARE_SUPPORT_DOCTOR_FAIL'

export const UPDATE_HEALTHCARE_SUPPORT_DOCTOR_REQUEST = 'UPDATE_HEALTHCARE_SUPPORT_DOCTOR_REQUEST'
export const UPDATE_HEALTHCARE_SUPPORT_DOCTOR_SUCCESS = 'UPDATE_HEALTHCARE_SUPPORT_DOCTOR_SUCCESS'
export const UPDATE_HEALTHCARE_SUPPORT_DOCTOR_FAIL = 'UPDATE_HEALTHCARE_SUPPORT_DOCTOR_FAIL'

// ** Healthcare Support - Nurse
export const CREATE_HEALTHCARE_SUPPORT_NURSE_REQUEST = 'CREATE_HEALTHCARE_SUPPORT_NURSE_REQUEST'
export const CREATE_HEALTHCARE_SUPPORT_NURSE_SUCCESS = 'CREATE_HEALTHCARE_SUPPORT_NURSE_SUCCESS'
export const CREATE_HEALTHCARE_SUPPORT_NURSE_FAIL = 'CREATE_HEALTHCARE_SUPPORT_NURSE_FAIL'

export const DETAIL_HEALTHCARE_SUPPORT_NURSE_REQUEST = 'DETAIL_HEALTHCARE_SUPPORT_NURSE_REQUEST'
export const DETAIL_HEALTHCARE_SUPPORT_NURSE_SUCCESS = 'DETAIL_HEALTHCARE_SUPPORT_NURSE_SUCCESS'
export const DETAIL_HEALTHCARE_SUPPORT_NURSE_FAIL = 'DETAIL_HEALTHCARE_SUPPORT_NURSE_FAIL'

export const UPDATE_HEALTHCARE_SUPPORT_NURSE_REQUEST = 'UPDATE_HEALTHCARE_SUPPORT_NURSE_REQUEST'
export const UPDATE_HEALTHCARE_SUPPORT_NURSE_SUCCESS = 'UPDATE_HEALTHCARE_SUPPORT_NURSE_SUCCESS'
export const UPDATE_HEALTHCARE_SUPPORT_NURSE_FAIL = 'UPDATE_HEALTHCARE_SUPPORT_NURSE_FAIL'

// ** Healthcare Support - Laboratory Analyst
export const CREATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_REQUEST = 'CREATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_REQUEST'
export const CREATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_SUCCESS = 'CREATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_SUCCESS'
export const CREATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_FAIL = 'CREATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_FAIL'

export const DETAIL_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_REQUEST = 'DETAIL_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_REQUEST'
export const DETAIL_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_SUCCESS = 'DETAIL_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_SUCCESS'
export const DETAIL_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_FAIL = 'DETAIL_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_FAIL'

export const UPDATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_REQUEST = 'UPDATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_REQUEST'
export const UPDATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_SUCCESS = 'UPDATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_SUCCESS'
export const UPDATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_FAIL = 'UPDATE_HEALTHCARE_SUPPORT_LABORATORY_ANALYST_FAIL'
